// extracted by mini-css-extract-plugin
export default {"image-card":"ImageCard_image-card__-aUyW"};